var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BjDivider",
        { attrs: { "right-fixed": "" } },
        [
          _vm._v(
            _vm._s(_vm.$t("BusinessImportHistory.page.GeneralImport")) + " "
          ),
          _c(
            "template",
            { slot: "right" },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v(_vm._s(_vm.$t("cancelText"))),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.handleConfirm("form")
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("saveText")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            inline: true,
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "180px",
          },
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "templateName",
                    label: _vm.$t("BusinessImportHistory.page.templateName"),
                  },
                },
                [
                  _c("BjInput", {
                    model: {
                      value: _vm.form.templateName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "templateName", $$v)
                      },
                      expression: "form.templateName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "templateCode",
                    label: _vm.$t("BusinessImportHistory.page.templateCode"),
                  },
                },
                [
                  !_vm.isEdit
                    ? _c("BjInput", {
                        model: {
                          value: _vm.form.templateCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "templateCode", $$v)
                          },
                          expression: "form.templateCode",
                        },
                      })
                    : _c("span", [_vm._v(_vm._s(_vm.form.templateCode))]),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "templateType",
                    label: _vm.$t("BusinessImportHistory.page.TemplateType"),
                  },
                },
                [
                  _c("BjSelectLov", {
                    attrs: {
                      disabled: "",
                      "option-list": _vm.IMPORT_GENERAL_TYPE_LIST,
                    },
                    model: {
                      value: _vm.form.templateType,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "templateType", $$v)
                      },
                      expression: "form.templateType",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "prefixPatch",
                    label: _vm.$t("BusinessImportHistory.page.pathPrefix"),
                  },
                },
                [
                  _c("BjInput", {
                    model: {
                      value: _vm.form.prefixPatch,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "prefixPatch", $$v)
                      },
                      expression: "form.prefixPatch",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "description",
                    label: _vm.$t("BusinessImportHistory.page.Description"),
                  },
                },
                [
                  _c("BjInput", {
                    model: {
                      value: _vm.form.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "description", $$v)
                      },
                      expression: "form.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "fragmentFlag",
                    label: _vm.$t("BusinessImportHistory.page.Slicing"),
                  },
                },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.form.fragmentFlag,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "fragmentFlag", $$v)
                      },
                      expression: "form.fragmentFlag",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { prop: "enabledFlag", label: _vm.$t("enableText") } },
                [
                  _c("el-switch", {
                    attrs: { "active-value": 1, "inactive-value": 0 },
                    model: {
                      value: _vm.form.enabledFlag,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "enabledFlag", $$v)
                      },
                      expression: "form.enabledFlag",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "",
                    label: _vm.$t("BusinessImportHistory.page.CustomTemplate"),
                  },
                },
                [
                  _c("BjUpload", {
                    ref: "BjUpload",
                    attrs: { "auto-upload": "" },
                    on: { afterUpload: _vm.afterUpload },
                  }),
                  _vm.form.templateUrl
                    ? _c("BjViewUrl", {
                        staticStyle: { width: "100px" },
                        attrs: { url: _vm.form.templateUrl },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "BjDivider",
            [
              _vm._v(
                _vm._s(_vm.$t("BusinessImportHistory.page.SheetPage")) + " "
              ),
              _c(
                "template",
                { slot: "right" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.onAddSheet },
                    },
                    [_vm._v(_vm._s(_vm.$t("addText")))]
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "el-table",
            {
              attrs: {
                data: _vm.form.templateTargetList,
                stripe: "",
                border: "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "sheetIndex",
                  label: _vm.$t("BusinessImportHistory.page.numberPage"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var $index = ref.$index
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop:
                                "templateTargetList." + $index + ".sheetIndex",
                              rules: _vm.rules.sheetIndex,
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: { "option-list": _vm.SHEET_INDEX_LIST },
                              model: {
                                value: row.sheetIndex,
                                callback: function ($$v) {
                                  _vm.$set(row, "sheetIndex", $$v)
                                },
                                expression: "row.sheetIndex",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "sheetName",
                  label: _vm.$t("BusinessImportHistory.page.PageName"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var $index = ref.$index
                      return [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              prop:
                                "templateTargetList." + $index + ".sheetName",
                              rules: _vm.rules.sheetName,
                            },
                          },
                          [
                            _c("BjInput", {
                              attrs: {
                                maxlength: _vm.MAX_LENGTH.DEFAULT,
                                placeholder: _vm.$t(
                                  "BusinessImportHistory.page.PleasePageName"
                                ),
                                clearable: "",
                              },
                              model: {
                                value: row.sheetName,
                                callback: function ($$v) {
                                  _vm.$set(row, "sheetName", $$v)
                                },
                                expression: "row.sheetName",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "startLine",
                  label: _vm.$t("BusinessImportHistory.page.startLine"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-input-number", {
                          attrs: { min: 1, precision: 0, controls: false },
                          model: {
                            value: row.startLine,
                            callback: function ($$v) {
                              _vm.$set(row, "startLine", $$v)
                            },
                            expression: "row.startLine",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "enabledFlag",
                  label: _vm.$t("enableText"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("el-checkbox", {
                          attrs: { "true-label": 1, "false-label": 0 },
                          model: {
                            value: row.enabledFlag,
                            callback: function ($$v) {
                              _vm.$set(row, "enabledFlag", $$v)
                            },
                            expression: "row.enabledFlag",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("table.operationText"),
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      var $index = ref.$index
                      return [
                        row.id
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onShow(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "BusinessImportHistory.page.templateColumns"
                                    )
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.onDelete($index)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("delText")))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }